import React, { Component } from 'react'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import { setOrderDetailPage } from '../../action/action'
import { popupColorSet } from '../../JS/setColors'

class OrderDetail extends Component {

    onNoClick = () => {
        this.props.setOrderDetailPage(false, {});
    }
    componentDidMount() {
        popupColorSet(this.props.menuColor);
    }
    render() {
        console.log("orderDetail", this.props.orderDetail)
        return (
            <div class="overlay">
                <div id="svc" className="overlay-body">
                    <div className="overlay-close" onClick={this.onNoClick}>
                        <i class="fa fa-close" style={{ color: "inherit" }}></i>
                    </div>
                    <table class="w-100" cellpadding="10">
                        <thead>
                            <tr>
                                <th style={{ padding: '10px' }} class="w-45">Description</th>
                                <th class="w-25">Qty</th>
                                <th class="w-25">Amount</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.orderDetail.item ?
                                < tr >
                                    <td style={{ padding: '10px' }}>
                                        <a>
                                            {this.props.orderDetail.item.itemName}
                                        </a>
                                    </td>
                                    <td>
                                        {this.props.orderDetail.quantity}
                                    </td>
                                    <td>
                                        {`${this.props.currencyCode} ${this.props.orderDetail.item.itemPrice * this.props.orderDetail.quantity}`}
                                    </td>
                                </tr> : ""
                            }
                            {this.props.orderDetail.addOns.length > 0 ?
                                <h2 style={{ fontWeight: "bold", marginLeft: "10px" }}>
                                    Additonal Request:
                                </h2> : null
                            }
                            {
                                this.props.orderDetail.addOns.length > 0 ?
                                    this.props.orderDetail.addOns.map((iterator) => {
                                        return (
                                            < tr >
                                                <td style={{ padding: '10px' }}>
                                                    <a>
                                                        {iterator.name}
                                                    </a>
                                                </td>
                                                <td>
                                                    1
                                                </td>
                                                <td>
                                                    {`${this.props.currencyCode} ${iterator.price}`}
                                                </td>
                                            </tr>
                                        )
                                    }) : ''
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2" style={{ padding: '10px' }}><strong>Total</strong></td>
                                <td colspan="2"><strong>{`${this.props.currencyCode} ${this.props.orderDetail.totalPrice.toFixed(2)}`}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        orderDetail: state.store.Hcommerce.orderDetail,
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : ""
    }
}

export default connect(
    mapStateToProps,
    {
        setOrderDetailPage
    }
)(OrderDetail);